import { clone } from 'lodash';
import AuthorizationManager from '@/authorization/authorization-manager.js';

export default {
	props: {
		authorization: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			defaultAuthorization: {
				policies: ['InternalSupportTech']
			}
		};
	},
	computed: {
		isInternalUser() {
			const oidcUser = this.$store.getters['oidcStore/oidcUser'];
			return oidcUser?.SupportTech === 'True';
		}
	},
	methods: {
		ValidateAuthorization() {
			return AuthorizationManager.validate(
				this.authorization || clone(this.defaultAuthorization)
			);
		}
	}
};
